import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { CommunicationsPage } from 'app/modules/communications/CommunicationsPage';
import { EmailUnsubscribePage } from 'app/modules/communications/EmailUnsubscribePage';
import { ContractsPage } from 'app/modules/contracts/ContractsPage';
import { FeatureToggle } from 'app/modules/feature-flags/FeatureToggle';
import HistoryPage from 'app/modules/history/HistoryPage';
import { EmailPage } from 'app/modules/organizations/components/EmailPage';
import { OrganizationsPage } from 'app/modules/organizations/OrganizationsPage';
import RegistrationPage from 'app/modules/registration/RegistrationPage';
import { LogoutPage } from "../../auth/LogoutPage";
import { LoadingSpinner } from "../components/LoadingSpinner";
import { ErrorFallback } from "../error/ErrorFallback";
import NotFound from "../NotFound/NotFound";
import { SentryRoute } from "../SentryRoute";
import DashboardPage from "../../dashboard/DashboardPage";
import { RequireAuth, useMeQuery, UserRole } from 'legoland-sdk/dist/experimental';
import { Redirect, Switch, useLocation, useRouteMatch } from 'react-router-dom';
import { ReleaseNotesPage } from "../../release-notes/ReleaseNotesPage";
import ReportsPage from "../../reports/ReportsPage";
import SettingsPage from "../../settings/SettingsPage";
import EditUser from "../../users/details/EditUser";
import { UsersListPage } from "../../users/list/UsersListPage";
import LoginPage from "../../auth/Login/LoginPage";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AppRoutes = () => {
  const anonPagesMatch = useRouteMatch('/(login|register)');
  const logoutPageMatch = useRouteMatch('/logout');
  const emailPageMatch = useRouteMatch('/ref-links');
  const {
    data,
    error,
    isLoading,
    isSuccess
  } = useMeQuery();
  const isAuthenticated = isSuccess && data?.me;
  const searchParams = new URLSearchParams(useLocation()?.search);
  if (logoutPageMatch) {
    return /*#__PURE__*/_jsx(LogoutPage, {});
  }
  if (error) {
    return /*#__PURE__*/_jsx(ErrorFallback, {
      error: error
    });
  }
  if (isLoading) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {});
  }
  if (isAuthenticated && anonPagesMatch) {
    if (searchParams.has('subscriptionId')) {
      return /*#__PURE__*/_jsx(LoginPage, {});
    } else {
      return /*#__PURE__*/_jsx(Redirect, {
        to: "/dashboard"
      });
    }
  }
  if (emailPageMatch) {
    return /*#__PURE__*/_jsx(RequireAuth, {
      autoRedirect: true,
      children: /*#__PURE__*/_jsx(EmailPage, {})
    });
  }
  return /*#__PURE__*/_jsxs(Switch, {
    "data-sentry-element": "Switch",
    "data-sentry-component": "AppRoutes",
    "data-sentry-source-file": "AppRoutes.tsx",
    children: [/*#__PURE__*/_jsx(SentryRoute, {
      exact: true,
      path: "/",
      "data-sentry-element": "SentryRoute",
      "data-sentry-source-file": "AppRoutes.tsx",
      "data-sentry-element": "SentryRoute",
      children: isAuthenticated ? /*#__PURE__*/_jsx(Redirect, {
        to: "/dashboard"
      }) : /*#__PURE__*/_jsx(Redirect, {
        to: "/login"
      })
    }), /*#__PURE__*/_jsx(SentryRoute, {
      path: "/login",
      "data-sentry-element": "SentryRoute",
      "data-sentry-source-file": "AppRoutes.tsx",
      "data-sentry-element": "SentryRoute",
      children: /*#__PURE__*/_jsx(LoginPage, {
        "data-sentry-element": "LoginPage",
        "data-sentry-source-file": "AppRoutes.tsx",
        "data-sentry-element": "LoginPage"
      })
    }), /*#__PURE__*/_jsx(SentryRoute, {
      path: "/register",
      "data-sentry-element": "SentryRoute",
      "data-sentry-source-file": "AppRoutes.tsx",
      "data-sentry-element": "SentryRoute",
      children: /*#__PURE__*/_jsx(RegistrationPage, {
        "data-sentry-element": "RegistrationPage",
        "data-sentry-source-file": "AppRoutes.tsx",
        "data-sentry-element": "RegistrationPage"
      })
    }), /*#__PURE__*/_jsx(SentryRoute, {
      path: "/unsubscribe",
      "data-sentry-element": "SentryRoute",
      "data-sentry-source-file": "AppRoutes.tsx",
      "data-sentry-element": "SentryRoute",
      children: /*#__PURE__*/_jsx(EmailUnsubscribePage, {
        "data-sentry-element": "EmailUnsubscribePage",
        "data-sentry-source-file": "AppRoutes.tsx",
        "data-sentry-element": "EmailUnsubscribePage"
      })
    }), /*#__PURE__*/_jsx(SentryRoute, {
      path: "/dashboard/(contact)?/(sales|support)?",
      "data-sentry-element": "SentryRoute",
      "data-sentry-source-file": "AppRoutes.tsx",
      "data-sentry-element": "SentryRoute",
      children: /*#__PURE__*/_jsx(RequireAuth, {
        autoRedirect: true,
        "data-sentry-element": "RequireAuth",
        "data-sentry-source-file": "AppRoutes.tsx",
        "data-sentry-element": "RequireAuth",
        children: /*#__PURE__*/_jsx(DashboardPage, {
          "data-sentry-element": "DashboardPage",
          "data-sentry-source-file": "AppRoutes.tsx",
          "data-sentry-element": "DashboardPage"
        })
      })
    }), /*#__PURE__*/_jsx(SentryRoute, {
      path: "/users/edit/:username/:activetab?",
      "data-sentry-element": "SentryRoute",
      "data-sentry-source-file": "AppRoutes.tsx",
      "data-sentry-element": "SentryRoute",
      children: /*#__PURE__*/_jsx(RequireAuth, {
        autoRedirect: true,
        fallback: /*#__PURE__*/_jsx(Redirect, {
          to: "/dashboard"
        }),
        role: [UserRole.Admin, UserRole.Distributor, UserRole.Support],
        "data-sentry-element": "RequireAuth",
        "data-sentry-source-file": "AppRoutes.tsx",
        "data-sentry-element": "RequireAuth",
        children: /*#__PURE__*/_jsx(EditUser, {
          "data-sentry-element": "EditUser",
          "data-sentry-source-file": "AppRoutes.tsx",
          "data-sentry-element": "EditUser"
        })
      })
    }), /*#__PURE__*/_jsx(SentryRoute, {
      path: "/users/",
      "data-sentry-element": "SentryRoute",
      "data-sentry-source-file": "AppRoutes.tsx",
      "data-sentry-element": "SentryRoute",
      children: /*#__PURE__*/_jsx(RequireAuth, {
        autoRedirect: true,
        fallback: /*#__PURE__*/_jsx(Redirect, {
          to: "/dashboard"
        }),
        role: [UserRole.Admin, UserRole.Distributor, UserRole.Support],
        "data-sentry-element": "RequireAuth",
        "data-sentry-source-file": "AppRoutes.tsx",
        "data-sentry-element": "RequireAuth",
        children: /*#__PURE__*/_jsx(UsersListPage, {
          "data-sentry-element": "UsersListPage",
          "data-sentry-source-file": "AppRoutes.tsx",
          "data-sentry-element": "UsersListPage"
        })
      })
    }), /*#__PURE__*/_jsx(SentryRoute, {
      path: "/organizations/",
      "data-sentry-element": "SentryRoute",
      "data-sentry-source-file": "AppRoutes.tsx",
      "data-sentry-element": "SentryRoute",
      children: /*#__PURE__*/_jsx(RequireAuth, {
        autoRedirect: true,
        fallback: /*#__PURE__*/_jsx(Redirect, {
          to: "/dashboard"
        }),
        role: [UserRole.Admin, UserRole.Distributor, UserRole.Support],
        "data-sentry-element": "RequireAuth",
        "data-sentry-source-file": "AppRoutes.tsx",
        "data-sentry-element": "RequireAuth",
        children: /*#__PURE__*/_jsx(OrganizationsPage, {
          "data-sentry-element": "OrganizationsPage",
          "data-sentry-source-file": "AppRoutes.tsx",
          "data-sentry-element": "OrganizationsPage"
        })
      })
    }), /*#__PURE__*/_jsx(SentryRoute, {
      path: "/reports",
      "data-sentry-element": "SentryRoute",
      "data-sentry-source-file": "AppRoutes.tsx",
      "data-sentry-element": "SentryRoute",
      children: /*#__PURE__*/_jsx(RequireAuth, {
        autoRedirect: true,
        "data-sentry-element": "RequireAuth",
        "data-sentry-source-file": "AppRoutes.tsx",
        "data-sentry-element": "RequireAuth",
        children: /*#__PURE__*/_jsx(ReportsPage, {
          "data-sentry-element": "ReportsPage",
          "data-sentry-source-file": "AppRoutes.tsx",
          "data-sentry-element": "ReportsPage"
        })
      })
    }), /*#__PURE__*/_jsx(SentryRoute, {
      path: "/history",
      "data-sentry-element": "SentryRoute",
      "data-sentry-source-file": "AppRoutes.tsx",
      "data-sentry-element": "SentryRoute",
      children: /*#__PURE__*/_jsx(RequireAuth, {
        autoRedirect: true,
        role: [UserRole.Admin, UserRole.Support],
        "data-sentry-element": "RequireAuth",
        "data-sentry-source-file": "AppRoutes.tsx",
        "data-sentry-element": "RequireAuth",
        children: /*#__PURE__*/_jsx(HistoryPage, {
          "data-sentry-element": "HistoryPage",
          "data-sentry-source-file": "AppRoutes.tsx",
          "data-sentry-element": "HistoryPage"
        })
      })
    }), /*#__PURE__*/_jsx(SentryRoute, {
      path: "/settings",
      "data-sentry-element": "SentryRoute",
      "data-sentry-source-file": "AppRoutes.tsx",
      "data-sentry-element": "SentryRoute",
      children: /*#__PURE__*/_jsx(RequireAuth, {
        autoRedirect: true,
        "data-sentry-element": "RequireAuth",
        "data-sentry-source-file": "AppRoutes.tsx",
        "data-sentry-element": "RequireAuth",
        children: /*#__PURE__*/_jsx(SettingsPage, {
          "data-sentry-element": "SettingsPage",
          "data-sentry-source-file": "AppRoutes.tsx",
          "data-sentry-element": "SettingsPage"
        })
      })
    }), /*#__PURE__*/_jsx(SentryRoute, {
      path: "/release-notes-editor",
      "data-sentry-element": "SentryRoute",
      "data-sentry-source-file": "AppRoutes.tsx",
      "data-sentry-element": "SentryRoute",
      children: /*#__PURE__*/_jsx(RequireAuth, {
        autoRedirect: true,
        fallback: /*#__PURE__*/_jsx(Redirect, {
          to: "/dashboard"
        }),
        role: UserRole.Admin,
        "data-sentry-element": "RequireAuth",
        "data-sentry-source-file": "AppRoutes.tsx",
        "data-sentry-element": "RequireAuth",
        children: /*#__PURE__*/_jsx(CommunicationsPage, {
          "data-sentry-element": "CommunicationsPage",
          "data-sentry-source-file": "AppRoutes.tsx",
          "data-sentry-element": "CommunicationsPage"
        })
      })
    }), /*#__PURE__*/_jsx(SentryRoute, {
      path: "/release-notes",
      "data-sentry-element": "SentryRoute",
      "data-sentry-source-file": "AppRoutes.tsx",
      "data-sentry-element": "SentryRoute",
      children: /*#__PURE__*/_jsx(RequireAuth, {
        autoRedirect: true,
        "data-sentry-element": "RequireAuth",
        "data-sentry-source-file": "AppRoutes.tsx",
        "data-sentry-element": "RequireAuth",
        children: /*#__PURE__*/_jsx(ReleaseNotesPage, {
          "data-sentry-element": "ReleaseNotesPage",
          "data-sentry-source-file": "AppRoutes.tsx",
          "data-sentry-element": "ReleaseNotesPage"
        })
      })
    }), /*#__PURE__*/_jsx(SentryRoute, {
      path: "/contracts",
      "data-sentry-element": "SentryRoute",
      "data-sentry-source-file": "AppRoutes.tsx",
      "data-sentry-element": "SentryRoute",
      children: /*#__PURE__*/_jsx(RequireAuth, {
        autoRedirect: true,
        fallback: /*#__PURE__*/_jsx(Redirect, {
          to: "/dashboard"
        }),
        role: [UserRole.Support, UserRole.Admin, UserRole.Distributor],
        "data-sentry-element": "RequireAuth",
        "data-sentry-source-file": "AppRoutes.tsx",
        "data-sentry-element": "RequireAuth",
        children: /*#__PURE__*/_jsx(FeatureToggle, {
          name: "contracts",
          off: /*#__PURE__*/_jsx(NotFound, {}),
          "data-sentry-element": "FeatureToggle",
          "data-sentry-source-file": "AppRoutes.tsx",
          "data-sentry-element": "FeatureToggle",
          children: /*#__PURE__*/_jsx(ContractsPage, {
            "data-sentry-element": "ContractsPage",
            "data-sentry-source-file": "AppRoutes.tsx",
            "data-sentry-element": "ContractsPage"
          })
        })
      })
    }), /*#__PURE__*/_jsx(SentryRoute, {
      "data-sentry-element": "SentryRoute",
      "data-sentry-source-file": "AppRoutes.tsx",
      "data-sentry-element": "SentryRoute",
      children: /*#__PURE__*/_jsx(NotFound, {
        "data-sentry-element": "NotFound",
        "data-sentry-source-file": "AppRoutes.tsx",
        "data-sentry-element": "NotFound"
      })
    })]
  });
};